(function () {
    'use strict';

    angular.module('app', [
        // Core Modules
        'app.core',
        'app.shared',

        // View Modules
        'app.home',
        'app.login',
        'app.scoring',
        'app.postScore',
        'app.accountSettings',
        'app.courseHandicap',
        'app.associationAdmin',
        'app.clubAdmin',
        'app.memberAdmin',
        'app.score-detail',
        'app.password-reset',
        'app.test'
    ]);
})();